import { FC, useState } from "react";
import ButtonComponent from "../../../../../../common/components/button/button.component";
import Column from "../../../../../../common/components/grid/column";
import Row from "../../../../../../common/components/grid/row";
import MapComponent from "../../../../../../common/components/map/map.component";
import MapMarker from "../../../../../../common/components/map/types/map-marker";
import TableDeleteButtonComponent from "../../../../../../common/components/table/button/delete/table-delete-button.component";
import TableComponent from "../../../../../../common/components/table/table.component";
import TableRow from "../../../../../../common/components/table/types/table-row";
import appTranslationsHelper from "../../../../../../languages/app-translations.helper";
import { useSignUpPassengerContext } from "../../common/context/sign-up-passenger.context";
import SignUpPassengerUserAddressAddComponent from "./add/sign-up-passenger-user-address-add.component";
import signUpPassengerUserAddressHelper from "./sign-up-passenger-user-address.helper";

const SignUpPassengerUserAddressComponent: FC = () => {
  const translations =
    appTranslationsHelper.getPassengerSignUpTranslations().userDataForm;

  const {
    userData: { addresses },
    removeUserDataAddress,
  } = useSignUpPassengerContext();

  const [isAddNewAddressModalOpen, setIsAddNewAddressModalOpen] =
    useState(false);

  const mapMarkers: MapMarker[] = addresses.map((address) => {
    return {
      coordinate: {
        latitude: address.latitude,
        longitude: address.longitude,
      },
      title: signUpPassengerUserAddressHelper.getAddressLabel(address),
      tooltip: signUpPassengerUserAddressHelper.getAddressLabel(address),
    };
  });

  const openAddNewAddressModal = () => {
    setIsAddNewAddressModalOpen(true);
  };

  const closeAddNewAddressModal = () => {
    setIsAddNewAddressModalOpen(false);
  };

  const tableRows: TableRow[] = addresses.map((address, index) => {
    return {
      id: String(index),
      value: {
        address: (
          <div className="sign_up_passenger_address_table_row address">
            <div className="text_ellipsis">
              {signUpPassengerUserAddressHelper.getAddressLabel(address)}
            </div>
          </div>
        ),
        actions: (
          <TableDeleteButtonComponent
            onClick={() => removeUserDataAddress(index)}
          />
        ),
      },
    };
  });

  return (
    <div className="sign_up_passenger_address">
      <Row>
        <Column xl={4}>
          <TableComponent
            columns={[
              {
                accessor: "address",
                header: translations.addressTableHeader.addressName,
                title: translations.addressTableHeader.addressName,
                colSpan: 4,
              },
              {
                accessor: "actions",
                header: "Actions",
                title: "",
              },
            ]}
            rows={tableRows}
          />
          <div className="sign_up_passenger_address__add_button_wrapper">
            <ButtonComponent
              onClick={openAddNewAddressModal}
              title={translations.addNewAddressButtonTitle}
              type="primary"
              idForTesting="user-data-open-add-new-address-modal-button"
            >
              {translations.addNewAddressButtonText}
            </ButtonComponent>
          </div>
        </Column>
        <Column xl={8}>
          <div className="sign_up_passenger_address__map_wrapper">
            <MapComponent markers={mapMarkers} autoFit autoFitOnUpdate />
          </div>
        </Column>
      </Row>
      <SignUpPassengerUserAddressAddComponent
        isModalOpen={isAddNewAddressModalOpen}
        onCloseClick={closeAddNewAddressModal}
      />
    </div>
  );
};

export default SignUpPassengerUserAddressComponent;
